import get from 'lodash.get';

import { ORDER, SORTING } from './constants';

import { User } from '../UsersListPage/helpers';

export const sortAlphabetical = (
  data: User[],
  order: string,
  accessor: string,
): User[] =>
  data.sort((data1: User, data2: User) => {
    const datum1 = get(data1, accessor) || '';
    const datum2 = get(data2, accessor) || '';
    if (order === ORDER.INVERSE) return datum2.localeCompare(datum1);
    return datum1.localeCompare(datum2);
  });

// Sorts the data according to sorting and order
export const sortData = (
  data?: User[],
  sorting?: string,
  order: string = '',
) => {
  if (!data) return null;

  // If no jobs, return null to show the placeholder
  if (data.length === 0) return [];

  // If sorting is updated_at, return data sorted by updated at date
  if (sorting === SORTING.NAME) return sortAlphabetical(data, order, 'name');
  // If sorting is updated_at, return data sorted by updated at date
  if (sorting === SORTING.LASTNAME)
    return sortAlphabetical(data, order, 'lastName');
  // If sorting is created_at, return data sorted by updated at date
  if (sorting === SORTING.EMAIL) return sortAlphabetical(data, order, 'email');
  // If sorting is updated_at, return data sorted by updated at date
  if (sorting === SORTING.COMPANY)
    return sortAlphabetical(data, order, 'company');
  // If sorting is updated_at, return data sorted by updated at date
  if (sorting === SORTING.MOBILE)
    return sortAlphabetical(data, order, 'mobile');

  return data;
};
